export default __webpack_public_path__ + "static/ugur-akkar-0772013ca62664506629c5b6d2192dc0.jpg";